"use client";

import { useEffect } from "react";
import { errorTracking } from "@/lib/error-tracking";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to error tracking service
    errorTracking.logError(error, {
      digest: error.digest,
      source: "global-error-boundary",
    });
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen p-8 bg-gray-50">
          <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-6 text-center max-w-md">
            We apologize for the inconvenience. A critical error occurred.
          </p>
          <div className="flex gap-4">
            <button
              onClick={reset}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Try Again
            </button>
            <button
              onClick={() => {
                window.location.href = "/";
              }}
              className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
            >
              Go Home
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}